import { BriefingStructured } from "@connect/shared";
import { BriefingBody } from "./BriefingBody";
import { TypedBriefing } from "./TypedBriefing";

interface Props {
  body_json?: string | null;
  body_md?: string | null;
}

/**
 * Single render entry point for briefings. Prefers the structured JSON
 * shape (Pass 2+); falls back to the legacy markdown parser for briefs
 * generated before Pass 2. If a row somehow has neither, renders nothing
 * (caller is responsible for empty-state copy).
 *
 * Why a try/parse here instead of trusting the column: malformed JSON from
 * legacy rows or future schema drift would otherwise crash the page.
 */
export function BriefingRenderer({ body_json, body_md }: Props) {
  if (body_json) {
    try {
      const parsed = BriefingStructured.parse(JSON.parse(body_json));
      return <TypedBriefing data={parsed} />;
    } catch {
      // Drop through to markdown fallback. Don't surface the parse error —
      // empty briefings should never be a user-facing crash.
    }
  }
  if (body_md) return <BriefingBody body_md={body_md} />;
  return null;
}
